import { createBrowserRouter, createRoutesFromElements, Outlet, Route, RouterProvider } from "react-router-dom"
import React, { lazy, useEffect, useRef } from "react"
import Lenis from "lenis"
import { ThemeProvider } from "./provider/ThemeProvider"
import { Loading } from "./pages/Loading"
import { MediaQueryProvider } from "./provider/MediaQueryProvider"
import { Analytics } from "@vercel/analytics/react"
import { Footer } from "./components/Footer/Footer.component"
import { Navbar } from "./components/Navbar/Navbar.component"


const HomePageExport = lazy(() =>
  import("./pages/HomePage").then((module) => ({
    default: module.HomePage,
  }))
)
const NotePageExport = lazy(() =>
    import("./pages/Notes").then((module) => ({
      default: module.NotePage,
    }))
)
const ProjectDetailPageExport = lazy(() =>
    import("./pages/ProjectDetails").then((module) => ({
      default: module.ProjectDetailPage,
    }))
)
const NoteDetailPageExport = lazy(() =>
    import("./pages/Notes").then((module) => ({
      default: module.NoteDetailPage,
    }))
)

const NotFoundPageExport = lazy(() =>
  import("./pages/NotFound").then((module) => ({
    default: module.NotFoundPage,
  }))
)

const AppLayout = () => (
  <>
    <Navbar />
    <main><Outlet /></main>
    <Footer />
  </>
)

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<MediaQueryProvider></MediaQueryProvider>}>
      <Route element={<ThemeProvider></ThemeProvider>}>
        <Route element={<AppLayout />}>
          <Route index element={<React.Suspense fallback={<Loading />}><HomePageExport /></React.Suspense>}/>
          <Route path={"/notes"} element={<React.Suspense fallback={<Loading />}><NotePageExport /></React.Suspense>} />
          <Route path={"/notes/:noteSlug"} element={<React.Suspense fallback={<Loading />}><NoteDetailPageExport /></React.Suspense>}/>
          <Route path={"/project/:projectSlug"} element={<React.Suspense fallback={<Loading />}><ProjectDetailPageExport /></React.Suspense>} />
          <Route path="*" element={<React.Suspense fallback={<Loading />}><NotFoundPageExport /></React.Suspense>} />
        </Route>
      </Route>
    </Route>
  )
)

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.5,  // Scroll duration
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });


    const animate = (time: any) => {
      lenis.raf(time);
      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);

    return () => {
      lenis.destroy();
    };
  }, []);
  return <>
    <RouterProvider router={router}></RouterProvider>
    <Analytics />
  </>
}

export default App;